import * as React from 'react'

import * as styles from './price.module.css'

interface IProps {
  amount: string
  pricePeriod?: string | null
}

const Price = ({ amount, pricePeriod }: IProps) => {
  return (
    <div className={styles.price}>
      ${amount}
      {pricePeriod && `/${pricePeriod}`}
    </div>
  )
}

export default Price
